window.DistributorTheme = (function () {
  var STORAGE_ENABLED = 'distributor_debug_enabled';
  var STORAGE_COUNTRY = 'distributor_debug_country';

  function readData() {
    var node = document.getElementById('DistributorData');
    if (!node) return [];

    try {
      return JSON.parse(node.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function isDebugEnabled() {
    if (!(window.Shopify && window.Shopify.designMode)) return false;
    try {
      return localStorage.getItem(STORAGE_ENABLED) === '1';
    } catch (e) {
      return false;
    }
  }

  function getEffectiveCountry() {
    var override = null;
    if (isDebugEnabled()) {
      try { override = localStorage.getItem(STORAGE_COUNTRY); } catch (e) {}
    }
    if (override) return override.trim().toUpperCase();

    return (document.body.dataset.detectedCountry || '').toUpperCase();
  }

  function getDistributor(fallbackToFirst) {
    var country = getEffectiveCountry();
    var data = readData();
    var match = data.filter(function (entry) {
      return String(entry.country || '').trim().toUpperCase() === country;
    })[0];

    if (!match && fallbackToFirst) match = data[0];

    return match || null;
  }

  function getBuyerLocationIds() {
    try {
      return JSON.parse(document.body.dataset.companyLocationIds || '[]') || [];
    } catch (e) {
      return [];
    }
  }

  function normalizeLocationId(value) {
    return String(value == null ? '' : value).trim().replace(/^gid:\/\/shopify\/CompanyLocation\//, '');
  }

  function isExemptBuyer(distributor) {
    if (!distributor || !distributor.company_location_id) return false;

    var locations = getBuyerLocationIds();
    if (!Array.isArray(locations)) return false;
    var buyerLocationIds = locations.map(normalizeLocationId);
    if (!buyerLocationIds.length) return false;

    return buyerLocationIds.indexOf(normalizeLocationId(distributor.company_location_id)) !== -1;
  }

  function initDebugBar() {
    // Country simulation is available only inside the theme editor.
    if (!(window.Shopify && window.Shopify.designMode)) return;
    var params = new URLSearchParams(window.location.search);
    if (params.has('distributor_debug')) {
      if (params.get('distributor_debug') === '1') {
        localStorage.setItem(STORAGE_ENABLED, '1');
      } else {
        localStorage.removeItem(STORAGE_ENABLED);
        localStorage.removeItem(STORAGE_COUNTRY);
      }
      params.delete('distributor_debug');
      var search = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (search ? '?' + search : '') + window.location.hash);
    }

    var bar = document.getElementById('DistributorDebugBar');
    if (!bar) return;

    // Preview-without-VPN (debug mode) off => remove the debug bar from the DOM entirely.
    if (!isDebugEnabled()) {
      bar.remove();
      return;
    }

    bar.hidden = false;

    var input = bar.querySelector('#DistributorDebugInput');
    var status = bar.querySelector('[data-role="status"]');
    var override = localStorage.getItem(STORAGE_COUNTRY);
    input.value = override || document.body.dataset.detectedCountry || '';

    if (override) status.textContent = 'Symulowany kraj: ' + override;

    bar.querySelector('[data-action="apply"]').addEventListener('click', function () {
      var code = input.value.trim().toUpperCase();
      if (!code) return;
      localStorage.setItem(STORAGE_COUNTRY, code);
      window.location.reload();
    });

    bar.querySelector('[data-action="clear"]').addEventListener('click', function () {
      localStorage.removeItem(STORAGE_COUNTRY);
      window.location.reload();
    });
  }

  function initFooterLink() {
    document.querySelectorAll('.js-distributor-block').forEach(function (block) {
      var distributor = getDistributor(false);
      if (!distributor) return;

      var link = block.querySelector('.js-distributor-link');
      if (!link) return;

      link.textContent = distributor.company_name;
      link.href = distributor.distributor_url;
      block.hidden = false;
    });
  }

  function logBuyerInfo() {
    var distributor = getDistributor(false);

    console.log('[Distributor] Wykryty kraj:', getEffectiveCountry());
    console.log('[Distributor] Zalogowany klient (email):', document.body.dataset.customerEmail || '(niezalogowany)');
    console.log('[Distributor] Firma B2B:', document.body.dataset.companyName || '(brak / nie B2B)');
    console.log('[Distributor] Company Location ID(y) klienta:', getBuyerLocationIds());
    console.log('[Distributor] Dystrybutor dla wykrytego kraju:', distributor);
    if (distributor) {
      console.log('[Distributor] Czy klient jest wyłącznym dystrybutorem tego kraju:', isExemptBuyer(distributor));
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDebugBar();
    initFooterLink();
    logBuyerInfo();
  });

  return {
    getDistributor: getDistributor,
    isDebugEnabled: isDebugEnabled,
    isExemptBuyer: isExemptBuyer
  };
})();
